import { render } from "./Jewellery.vue?vue&type=template&id=36156f82"
import script from "./Jewellery.vue?vue&type=script&lang=js"
export * from "./Jewellery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__